import * as yup from 'yup';
import { I18n } from 'react-redux-i18n';

export const getSchema = () => {
  const requiredFieldMessage = I18n.t('auth.requiredField');

  return yup.object().shape({
    created: yup.string().required(requiredFieldMessage),
    price: yup.string().required(requiredFieldMessage),
    currency: yup.string().required(requiredFieldMessage),
    email: yup.string().required(requiredFieldMessage),
    status: yup.string().required(requiredFieldMessage),
  });
};
